import { Component, OnInit, OnDestroy } from '@angular/core';
import { LiftModuleService } from '../../services/lift-module.service';
import { LiftModuleList } from '../../models/lift-module-list.model';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityDatatableComponent } from '../../../core/components/entity-datatable/entity-datatable.component';
import { LiftModuleCriteria } from '../../models/lift-module.criteria';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { ProgressBarService } from 'src/app/core/services/progress-bar.service';
import * as moment from 'moment';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';

@Component({
  selector: 'app-lift-module',
  templateUrl: './lift-module.component.html',
  styleUrls: ['./lift-module.component.css']
})
export class LiftModuleComponent extends EntityDatatableComponent<LiftModuleList, LiftModuleCriteria, LiftModuleService> implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private moduleService: LiftModuleService,
    entityListRefresh: EntityListRefresh,
    progressBarService: ProgressBarService,
    private uiNotificationService: UINotificationService
  ) {
    super(
      'lift-module',
      new LiftModuleCriteria(),
      entityListRefresh,
      moduleService,
      progressBarService
    );

    this.sortItems = [
      {
        title: 'Id',
        code: 'id',
        sortOrder: 'asc',
        width: 100,
        disabled: true,
        isEmpty: false,
        class: null
      },
      {
        title: 'Kód',
        code: 'Code',
        sortOrder: 'asc',
        width: 156,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'Připojen',
        code: 'IsConnected',
        sortOrder: 'asc',
        width: 150,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'Čas posledního připojení',
        code: 'ConnectionChanged',
        sortOrder: 'asc',
        width: 150,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'Akce',
        code: 'action',
        sortOrder: 'asc',
        width: 50,
        disabled: true,
        isEmpty: true,
        class: null
      }
    ];
  }

  ngOnInit() {
    this.initData(this.route.snapshot.data.liftModules);
  }

  ngOnDestroy() {
    this.destroyData();
  }

  goToDetail(id: number) {
    this.router.navigate([{ outlets: { modal: ['lift-module-detail', id] } }]);
  }

  createLiftModule() {
    this.router.navigate([{ outlets: { modal: 'create-lift-module' } }]);
  }

  delete(id: number, code: string) {
    if (confirm('Chcete opravdu smazat module '+ code +'?')) {
      this.moduleService.delete(id).subscribe(() => {
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Modul byl smazán'
        });
        this.reloadData();
      });
    }
  }

  search(term: string) {
    this.criteria.searchTerm = term;
    this.criteria.page = 1;
    this.reloadData();
  }

  formatDateTime(datetime: string) {
    if (!datetime) {
      return '-';
    }
    const lastLogin = moment(datetime);
    return lastLogin.format('DD.MM.YYYY HH:mm');
  }

  formatBoolean(state: boolean) {
    if (state) {
      return 'Ano';
    } else {
      return 'Ne';
    }
  }

}
